export default {
    shortFormat: 'MMM DD, YYYY',
    longFormat: 'MMM DD, YYYY hh:mm A',
    monthYearFormat: 'MMMM YYYY',
    inputDateFormats: ['MM/DD/YYYY', 'YYYY/MM/DD', 'MMM DD, YYYY'],
    fullDateTimeFormat: 'YYYY-MM-DDTHH:mm:ss.SSS',
    fullDateTimeFormatWithTimeZone: 'YYYY-MM-DDTHH:mm:ssZ'
}


// WEBPACK FOOTER //
// ./src/constants/moment-date-formats.js